import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApprovalTrackingComponent } from '../../../Component/ApprovalTracking/approval-tracking/approval-tracking.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-tax-declaration',
  standalone: true,
  imports: [FormsModule, CommonModule, DataTablesModule, RouterOutlet, RouterModule, NgbDatepickerModule, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './tax-declaration.component.html',
  styleUrl: './tax-declaration.component.scss'
})
export class TaxDeclarationComponent {
  isDisabled: boolean = false;

  FinancialYears: any[] = [];
  TableDatas: any[] = [];
  user = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    SelectType: 'S',
    ESS_EmpTaxDeclarationID: 0,
    EmpMasterId: null,
    FinancialYearFrom: '',
    FinancialYearFromObj: '',
    FinancialYearTo: '',
    FinancialYearToObj: '',
    IsDraft: true,
    ApprovalStatus: 'ALL',
    ModuleMasterId: 9,
    ESS_TaxFinancialYearID: null,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private incometax: IncometaxService,
    private session: SessionService,
    protected dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.Filter.EmpMasterId = this.user.UserId;
    this.ESS_TaxFinancialYearSelect();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      if (this.Filter.ESS_TaxFinancialYearID == null || this.Filter.ESS_TaxFinancialYearID == 0) {
        this.Filter.FinancialYearFrom = '';
        this.Filter.FinancialYearTo = '';
      } else {
        this.Filter.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
        this.Filter.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
      }
      this.ESS_EmpTaxDeclarationSelect();
    }
    else {
      form.submitted = true;
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_TaxFinancialYearSelect() {
    this.isDisabled = true;
    this.incometax.ESS_TaxFinancialYearSelect({ SelectType: 'S', ESS_TaxFinancialYearID: null, FinancialYearFrom: null, FinancialYearTo: null }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.FinancialYears = response.Table;
          this.FinancialYears.forEach(element => {
            element.FinancialYear = new Date(element.FinancialYearStart).getFullYear() + ' - ' + new Date(element.FinancialYearEnd).getFullYear();
          });

          this.Filter.ESS_TaxFinancialYearID = this.FinancialYears.filter(e => e.IsActive)[0].ESS_TaxFinancialYearID;
          if (this.Filter.ESS_TaxFinancialYearID == null || this.Filter.ESS_TaxFinancialYearID == 0) {
            this.Filter.FinancialYearFrom = '';
            this.Filter.FinancialYearTo = '';
          } else {
            this.Filter.FinancialYearFrom = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearStart).getFullYear() });
            this.Filter.FinancialYearTo = this.dateFormat.format({ day: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getDate(), month: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getMonth() + 1, year: new Date(this.FinancialYears.filter(e => e.ESS_TaxFinancialYearID == this.Filter.ESS_TaxFinancialYearID)[0].FinancialYearEnd).getFullYear() });
          }
          this.ESS_EmpTaxDeclarationSelect();
        } else {
          this.FinancialYears = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpTaxDeclarationSelect() {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxDeclarationSelect(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = [];
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    // this.TableDatas = [];
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
    this.ESS_EmpTaxDeclarationSelect();
  }

  Tracking(index: number) {
    const modalRef = this.modalService.open(ApprovalTrackingComponent, { size: 'lg' });
    modalRef.componentInstance.Detail.ModuleMasterId = this.Filter.ModuleMasterId;
    modalRef.componentInstance.Detail.EmpMasterId = this.Filter.EmpMasterId;
    modalRef.componentInstance.Detail.TransactionId = this.TableDatas[index].ESS_EmpTaxDeclarationID;
    modalRef.componentInstance.Detail.UserImage = this.TableDatas[index].Photo;
    modalRef.componentInstance.Detail.EmployeeName = this.TableDatas[index].EmpName;
    modalRef.componentInstance.Detail.EmpCode = this.TableDatas[index].EmpCode;
    modalRef.componentInstance.Detail.DesignationName = "";
    modalRef.result.then(result => { });
  }

  ESS_EmpTaxDeclaration_InsertUpdate(ID: number) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.isDisabled = true;
        this.incometax.ESS_EmpTaxDeclaration_InsertUpdate({ SelectType: 'DeleteDraft', ESS_EmpTaxDeclarationID: ID, }).subscribe({
          next: async (response) => {
            if (response.Error_Code == '690' || response.Error_Code == '721') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                this.ESS_EmpTaxDeclarationSelect();
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    })
  }
}
